import { BigNumber } from '@ethersproject/bignumber';
import { BurnRedeemOnChain } from '../src/classes/burnRedeemExtensionCore';
import { NULL_BYTES32  } from '../src/common/constants';

export const MOCK_BR = {
  paymentReceiver: '0x519c51e48d34c8923339680c6c04bcfe94d410ac',
  storageProtocol: 2,
  redeemedCount: 0,
  redeemAmount: 1,
  totalSupply: 10,
  startDate: 0, // this is in seconds unix epoch
  endDate: 0, // this is in seconds unix epoch
  cost: BigNumber.from(100000000000000),
  location: 'NM2gqj52jTdxjogQWItP4qCKEIje6xRXoewqrti07yA',
  burnSet: [
    {
      requiredCount: BigNumber.from(1), // uint256
      items: [
        {
          validationType: 1,
          contractAddress: "0x7a77F2cFB02546F217d39157471d5B5914DD7644",
          tokenSpec: 1,
          burnSpec: 1,
          amount: BigNumber.from(0),
          minTokenId: BigNumber.from(0),
          maxTokenId: BigNumber.from(0),
          merkleRoot: NULL_BYTES32,
        },
      ],
    },
    {
      requiredCount: BigNumber.from(1), // uint256
      items: [
        {
          validationType: 1,
          contractAddress: "0xb02BA141fA74ACFbF96e8cEc551F5260B178E84a",
          tokenSpec: 2,
          burnSpec: 1,
          amount: BigNumber.from(2),
          minTokenId: BigNumber.from(0),
          maxTokenId: BigNumber.from(0),
          merkleRoot: NULL_BYTES32,
        },
      ],
    },
  ],
} as BurnRedeemOnChain;
